exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabledBtn[data-v-3994daaa]{opacity:.5;cursor:default!important}.selected[data-v-3994daaa]{border:2px solid #fff}.change-img-container[data-v-3994daaa],.next-img-container[data-v-3994daaa],.prev-img-container[data-v-3994daaa]{position:absolute;top:0;bottom:35px;width:40px}.next-img-container[data-v-3994daaa]{right:0}.prev-img-container[data-v-3994daaa]{left:0}.next[data-v-3994daaa]:hover,.prev[data-v-3994daaa]:hover{background:#000}.super-img-block:hover .next[data-v-3994daaa],.super-img-block:hover .prev[data-v-3994daaa]{visibility:initial}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3994daaa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/gallery.vue
// module id = TS8A
// module chunks = 1